module.exports = __webpack_public_path__ + "img/conectada_01.375dd2a5.svg";